import React from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const Mypayments = () => {
  const user = useSelector((state) => state.user.user);
  const paidUsers = useSelector((state) => state.user.paid);
  const email = user[0].email;

  let remaining = paidUsers[0].totalamount - paidUsers[0].amount;
  return (
    <>
      <Row>
        <Col>
          <h4 className="d-flex justify-content-between align-items-center">
            <span>
              Course Amount &nbsp;
              <span className="text-success">
                {email ? paidUsers[0].totalamount : ""}
              </span>
            </span>{" "}
            <span>
              Remaining &nbsp;
              <span className="text-danger">{email ? remaining : ""}</span>
              &nbsp;&nbsp;
              {remaining > 0 && (
                <Button variant="outline-success" size="sm">
                  Pay now
                </Button>
              )}
            </span>
          </h4>
          <p>Payment transactions</p>
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Email</th>
                <th>Course Name</th>
                <th>Amount Paid</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {paidUsers.map((paid) => {
                return (
                  <tr key={paid.id}>
                    <td>{paid.email}</td>
                    <td>{paid.coursename}</td>
                    <td>{paid.amount}</td>
                    <td>{paid.purchased_date}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default Mypayments;
